module.exports = __webpack_public_path__ + "static/media/intro-mobile1.ec7ebf81.svg";